import { render } from "./password-forget.vue?vue&type=template&id=2d6a0bee&scoped=true"
import script from "./password-forget.vue?vue&type=script&lang=js"
export * from "./password-forget.vue?vue&type=script&lang=js"

import "./password-forget.vue?vue&type=style&index=0&id=2d6a0bee&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d6a0bee"]])

export default __exports__